import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { checkForOverride } from "../helpers/theme";
import useGetMediaLocation from "../hooks/useGetMediaLocation";


export default function Slideshow ({ cue }) {
	const { projectId } = useParams();
	const [current, setCurrent] = useState(cue.goTo || 0);
	const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);

	const baseTheme = useSelector((state) =>
		cue.theme
			? state?.main?.projects?.[projectId]?.themes?.[cue.theme]
			: state?.main?.projects?.[projectId]?.themes?.[selectedProject?.theme]
	);

	useEffect(() => {
		let interval;

		if (["offair", "ready", "cuedon"].includes(cue.status)) {
			return setCurrent(0);
		} else {
			if (cue.items.length === 1) return setCurrent(0);
			if (cue.loop === "manual") return setCurrent(parseInt(cue.goTo || 0));

			interval = setInterval(() => {
				let c = current;
				if (c === 0) {
					setCurrent(1)
				} else if (c > 0 && c < cue.items.length - 1) {
					setCurrent(current + 1)
				} else {
					if (cue.loop !== "looping") return
					setCurrent(0)
				}
			}, [cue.timePerSection * 1000 || 5000]);
		}

		return () => {
			clearInterval(interval);
		};
	}, [cue.status, cue.loop, cue.timePerSection, current, cue.goTo, cue.items]);

	return (
		<div
			className="relative w-screen h-s4 transition-all duration-1000"
		>
			{cue.items?.map((item, index) => {
				if (index + 1 > parseInt(cue.items.length || 3)) return null;
				const {
					title,
					image,
					url = "",
					imageFit = "cover",
				} = item;

				return (
					<SlideshowSection
						cue={cue}
						key={index}
						index={index}
						current={current}
						title={title}
						baseTheme={baseTheme}
						image={image}
						url={url}
						imageFit={imageFit}
					/>
				);
			})}
		</div>
	);
}

const SlideshowSection = ({
	cue,
	index,
	current,
	title,
	baseTheme,
	image,
	url,
	imageFit,
}) => {
	const mediaLocation = useGetMediaLocation();
	const cloud = useSelector((state) => state.rundown.cloud);

	return (
		<div
			style={{
				zIndex: index === current ? 10 : 0,
				backgroundColor: cue.bgColour || 'black'
			}}
			className="key_me absolute inset-0 h-screen flex flex-col items-start transition-[z-index] duration-1000"
		>
			<div
				style={{
					opacity: index === current ? '100' : 0,
					
				}}
				className=" h-screen w-full flex transition-opacity duration-1000"
			>
				{((image && image !== "none") || url) && (
					<img
						className={`items-center justify-center m-auto rounded-${checkForOverride(
							baseTheme,
							null,
							null,
							"background",
							"rounding"
						)}
						${imageFit === "cover" ? "object-cover h-full" : "object-contain h-auto w-full"}
						`}
						alt={title}
						src={`${mediaLocation}${cloud ? url : image}`}
					/>
				)}
				
			</div>
		</div>
	);
};
